import { FaIcon, faPlus } from '@/lib/fa'
import { faTrash } from '@fortawesome/pro-light-svg-icons'
import React from 'react'
import SearchColor from '@/assets/icons_new/SearchColor.svg'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import moment from 'moment'
import { TripEventType } from '@/app/constants/delegation/tripEventType'
import { HOMELAND } from '@/modules/drivers/utils/restOnBase'
import { removeTripEventsAt } from '@/modules/drivers/utils/eventListEdits'

const EventsActionBar = ({
  selectedIds,
  onUpdate,
  onAddArrayItem,
  setSelectedIds,
  events,
  setSearchValue,
  searchValue,
  filteredEventsLength,
}) => {
  const { t } = useLocalize()
  const handleAdd = () => {
    if (onAddArrayItem) {
      // WPF parity (TripItemCreator.CreateNew): homeland, and Begin only for the first event.
      onAddArrayItem('events', {
        lp: -1,
        date: moment().format('YYYY-MM-DD HH:mm'),
        city: '',
        country: HOMELAND,
        tripEvent: events?.length
          ? TripEventType.ChangeCountry
          : TripEventType.Begin,
        vehicleType: null,
        registrationNumber: '',
        isTransit: false,
        docNumber: '',
        comments: '',
      })
    }
  }

  const handleDelete = () => {
    if (selectedIds.length > 0) {
      onUpdate('events', removeTripEventsAt(events, selectedIds))
      setSelectedIds([])
    }
  }
  const containerRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(e.target as Node)
      ) {
        setSearchValue('')
        setShowSearch(false)
      }
    }
    document.addEventListener('click', handleClick)
    return () => document.removeEventListener('click', handleClick)
  }, [])
  const [showSearch, setShowSearch] = React.useState(false)

  const isSelectedAny = selectedIds.length > 0
  return (
    <div className="tw-flex tw-w-full tw-items-center tw-justify-between tw-border-b tw-border-[#e5e6e6] tw-bg-[#fafbff] tw-px-4 tw-py-3">
      {/* Left side - Actions */}
      <div className="tw-flex tw-items-center tw-gap-4">
        {/* Search button with dropdown */}
        <div className="tw-relative" ref={containerRef}>
          <div
            className={`tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-border-2 tw-px-1 ${
              showSearch
                ? 'tw-rounded-lg tw-border-primary'
                : 'tw-border-transparent'
            }`}
            onClick={() => setShowSearch((prev) => !prev)}
          >
            <img src={SearchColor} alt="Search Icon" />
            <p className="tw-text-sm tw-font-medium tw-text-primary">
              {t('common.search')}
            </p>
          </div>
          {showSearch && (
            <div className="tw-absolute tw-z-50 tw-mt-2 tw-w-[320px] tw-rounded-lg tw-bg-white tw-p-2 tw-shadow-md">
              <div className="tw-relative tw-w-full">
                <input
                  autoFocus
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  placeholder={t('common.search')}
                  className="tw-w-full tw-rounded tw-border tw-border-neutral-300 tw-px-3 tw-py-2 tw-text-sm focus:tw-outline-none"
                  onClick={(e) => e.stopPropagation()}
                />
                <div className="tw-absolute tw-right-2 tw-top-1/2 tw-flex tw--translate-y-1/2 tw-items-center tw-gap-2">
                  {searchValue && (
                    <>
                      <span className="tw-text-sm tw-text-gray-500">
                        {filteredEventsLength}
                      </span>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation()
                          setSearchValue('')
                        }}
                        className="tw-text-gray-400 hover:tw-text-gray-700"
                      >
                        ✕
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Add button */}
        <div
          className="tw-flex tw-h-5 tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-lg tw-px-2 hover:tw-bg-[#e5e6e6]"
          onClick={handleAdd}
          title={t('common.add')}
        >
          <FaIcon icon={faPlus} className="tw-h-4 tw-w-4 tw-text-[#2448bb]" />
          <span className="tw-text-sm tw-font-medium tw-text-[#2448bb]">
            {t('common.add')}
          </span>
        </div>

        {/* Delete button */}
        {isSelectedAny && (
          <div
            className="tw-flex tw-h-5 tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-lg tw-px-2 hover:tw-bg-[#e5e6e6]"
            onClick={handleDelete}
            title={t('common.delete')}
          >
            <FaIcon icon={faTrash} className="tw-h-4 tw-w-4 tw-text-error" />
            <span className="tw-text-sm tw-font-medium tw-text-error">
              {t('common.delete')} ({selectedIds.length})
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

export default EventsActionBar
